import { Component, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Campaign } from '../model';
import { CampaignServiceService } from '../campaign-service.service';
import { ToolbarModule } from 'primeng/toolbar';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';

@Component({
    selector: 'app-campaign-list',
    imports: [TableModule, ToolbarModule, ButtonModule, DatePipe],
    templateUrl: './campaign-list.component.html',
    styleUrl: './campaign-list.component.scss'
})
export class CampaignListComponent implements OnInit {

  protected data: Campaign[] = [];
  protected selectedItem: Campaign | null = null;

  constructor(
    private router: Router,
    private service: CampaignServiceService) {

  }

  ngOnInit(): void {
    this.service.getAll().subscribe(data => {
      this.data = data;
    });
  }

  addNew() {
    this.router.navigate(['/campaign/add']);
  }

  edit(campaign: Campaign) {
    this.router.navigate(['/campaign/edit', campaign.id]);
  }
}
